import React from 'react';
import { ExternalLink } from 'lucide-react';
import { prTitleClass } from '../../components/repository/repoViewTheme';

/** Repo short name linking to GitHub (`htmlUrl`); plain text when URL missing. */
export default function RepoGitHubNameLink({ htmlUrl, name, fullDisplay }: any) {
  const href = typeof htmlUrl === 'string' ? htmlUrl.trim() : '';
  if (!href) {
    return (
      <span className={`block min-w-0 truncate ${prTitleClass}`} title={fullDisplay}>
        {name}
      </span>
    );
  }
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex min-w-0 max-w-full items-center gap-1.5 ${prTitleClass} focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-purple/50 rounded`}
      title={fullDisplay}
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') e.stopPropagation();
      }}
    >
      <span className="min-w-0 flex-1 truncate">{name}</span>
      <ExternalLink className="h-3.5 w-3.5 shrink-0 text-slate-400" aria-hidden />
    </a>
  );
}
